import api from "@/domain/api/api.client"
import { apiPost } from "@/domain/api/api.request"
import { getIdentityId } from "@/domain/auth/auth.service"

export async function wizardSessions() {
    const identityId = getIdentityId()

    const res = await api.get(`/api/wizard/sessions/${identityId}`)
    return res.data
}
export async function loadIdentities() {
    const identityId = getIdentityId()

    const res = await api.get(`/api/wizard/organizations/${identityId}`)
    return res.data
}
export async function wizardStart() {
    const res = await api.post(`/api/wizard/start`)

    return res.data
}

export async function wizardStep(payload) {
    const res = await api.post("/api/wizard/step", payload)
    return res.data
}

export async function wizardFinalize(payload) {
    const res = await apiPost("/api/wizard/finalize", payload)
    return res.data
}